import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ListView, View } from 'react-native';

import CalendarMonth from './calendar-month';

import styles from './calendar.styles';

export default class Calendar extends PureComponent {
  static propTypes = {
    fromDate: CalendarMonth.propTypes.fromDate,
    toDate: CalendarMonth.propTypes.toDate,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    numberOfPastMonth: PropTypes.number,
    numberOfFutureMonth: PropTypes.number,
    monthNames: PropTypes.arrayOf(PropTypes.string),
    weekdayNames: CalendarMonth.propTypes.weekdayNames,
    highlightDays: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ])),
    onSelectDate: CalendarMonth.propTypes.onSelectDate,
  };

  // static defaultProps = {
  //   monthNames: [
  //     'January',
  //     'February',
  //     'March',
  //     'April',
  //     'May',
  //     'June',
  //     'July',
  //     'August',
  //     'September',
  //     'October',
  //     'November',
  //     'December',
  //   ],
  //   weekdayNames: [
  //     'Su',
  //     'Mo',
  //     'Tu',
  //     'We',
  //     'Th',
  //     'Fr',
  //     'Sa',
  //   ],
  // };

  constructor() {
    super();

    this.state = {
      dataSource: new ListView.DataSource({
        rowHasChanged: () => true,
      }),
    };
  }

  renderMonth(months){
    const sanitizedProps = sanitizeProps(this.props);
    const {
      fromDate,
      toDate,
      minDate,
      maxDate,
      weekdayNames,
      highlightDays,
      onSelectDate,
      numberOfPastMonth,
      numberOfFutureMonth,
      messages,
      languageCode
    } = sanitizedProps;
    const highlightDaysSet = createHighlightDaysSet(highlightDays);
  return(
    <div className="row small-up-1 medium-up-2">
      {
        months.map((monthData, index) => {
          return <div key={index} className="column cloumn-block">
              <CalendarMonth
              {...monthData}
              fromDate={fromDate}
              toDate={toDate}
              minDate={minDate}
              maxDate={maxDate}
              weekdayNames={messages['app.calendar.weekDays'].split(',')}
              highlightDays={highlightDaysSet}
              onSelectDate={onSelectDate}
              languageCode={languageCode}
              messages={messages}
            />
        </div>
        })
      }
    </div>
    );
  }

  render() {
    const sanitizedProps = sanitizeProps(this.props);
    const {
      fromDate,
      toDate,
      minDate,
      maxDate,
      weekdayNames,
      highlightDays,
      onSelectDate,
    } = sanitizedProps;
    const highlightDaysSet = createHighlightDaysSet(highlightDays);
    const months = createMonthsList(sanitizedProps);

    return (<div className="row">
      {
        this.renderMonth(months)
      }
    </div>);
  }
}
// utilities

function sanitizeProps(props) {
  let {
    fromDate,
    toDate,
    minDate = new Date(),
    maxDate,
  } = props;

  minDate = new Date(Date.UTC(minDate.getUTCFullYear(), minDate.getUTCMonth(), minDate.getUTCDate()));

  if (maxDate) {
    maxDate = new Date(Date.UTC(maxDate.getUTCFullYear(), maxDate.getUTCMonth(), maxDate.getUTCDate()));
  } else {
    maxDate = new Date(Date.UTC(
      minDate.getUTCFullYear() + 1,
      minDate.getUTCMonth(),
      minDate.getUTCDate())
    );
  }

  if (fromDate) {
    fromDate = new Date(Date.UTC(fromDate.getUTCFullYear(), fromDate.getUTCMonth(), fromDate.getUTCDate()));
  }

  if (toDate) {
    toDate = new Date(Date.UTC(toDate.getUTCFullYear(), toDate.getUTCMonth(), toDate.getUTCDate()));
  }

  return {
    ...props,
    fromDate,
    toDate,
    minDate,
    maxDate,
  };
}

function createMonthsList(props) {
  const {
    minDate,
    maxDate,
    monthNames,
    messages
  } = props;

  let date = new Date(minDate.getFullYear(), minDate.getMonth(), 1, minDate.getHours(), minDate.getMinutes());
  const months = [];

  while (date <= maxDate) {
    months.push({
      name: messages['app.calendar.months'].split(',')[date.getMonth()],
      date,
    });

    date = new Date(date.getFullYear(), date.getMonth() + 1, 1, minDate.getHours(), minDate.getMinutes());
  }

  let tempDate=new Date();
  let tempminDate=new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate()));


  // if((maxDate.toString())==(tempminDate.toString()))
  // {
  //   return months.reverse();
  // }
  // else {
    return months;
  // }

}

function createHighlightDaysSet(highlightDays) {
  const highlightDaysSet = new Set();

  for (let day of highlightDays || []) {
    if (typeof day === 'string') day = new Date(day);

    highlightDaysSet.add(
      new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate())).valueOf());
  }

  return highlightDaysSet;
}
